// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".slide[data-v-84cdfa74]{transition:left .15s ease-in}", "",{"version":3,"sources":["webpack://./resources/js/parts/floating-contact.vue"],"names":[],"mappings":"AACA,wBACI,4BAAJ","sourcesContent":["\n.slide {\n    transition: left 0.15s ease-in;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
